export default "__VITE_ASSET__D8XFv6To__"